"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_PAGEVIEWS_QUOTA = 4.5;
//# sourceMappingURL=default-pageviews-quota.js.map